import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { CollectionResponseDto } from '../../../store/landscapeAPI/collection/dto/response/collection-response.dto';
import { Action, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';

//import styles from './ReportingDetailsCollectionsOrganism.module.css';

interface ReportingDetailsCollectionsOrganismProps {
  data: CollectionResponseDto[];
  handleDeleteCollection: (id: string) => void;
}

const ReportingDetailsCollectionsOrganism: FC<
  ReportingDetailsCollectionsOrganismProps
> = ({ data, handleDeleteCollection }) => {
  const navigate = useNavigate();

  const handleUpdateCollection = (id: string) => {
    navigate(`/reporting-details/collections/${id}/edit`);
  };

  return (
    <SortableTable
      data={data}
      columns={[{ label: 'Collections', key: 'name' }]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.name}></Label>
          <Action
            type="edit"
            size="sm"
            onClick={() => handleUpdateCollection(row.id)}
          ></Action>
          <Action
            type="delete"
            size="sm"
            onClick={() => handleDeleteCollection(row.id)}
          ></Action>
        </TableRow>
      )}
    />
  );
};

export default ReportingDetailsCollectionsOrganism;
